export default __webpack_public_path__ + "static/media/OttoMann.767d65cc.png";